import type { ChargingEvent } from "../types";

interface EventLogProps {
  events: ChargingEvent[];
}

export default function EventLog({ events }: EventLogProps) {
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-2 text-base font-semibold text-slate-800">Charging Event Log</h3>
      <div className="max-h-52 overflow-y-auto rounded-lg border border-slate-100 bg-slate-50 p-2">
        {events.length === 0 ? (
          <p className="text-sm text-slate-500">No charging events yet.</p>
        ) : (
          <ul className="space-y-1">
            {events
              .slice()
              .reverse()
              .map((event, index) => (
                <li key={`${event.step}-${index}`} className="text-xs text-slate-700">
                  <span className="font-medium text-slate-900">{event.timeLabel}</span> - {event.event}
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
}
